import Vue from 'vue'
import Vuex from 'vuex'
import store from 'storejs'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const state = {
  login: '' || store.get('login')
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
